module.exports = __webpack_public_path__ + "static/media/24UHCHR2.60033c6f.jpg";